import { render } from "./partsConstruction.vue?vue&type=template&id=f1c4282c&scoped=true&ts=true"
import script from "./partsConstruction.vue?vue&type=script&lang=ts"
export * from "./partsConstruction.vue?vue&type=script&lang=ts"

import "./partsConstruction.vue?vue&type=style&index=0&id=f1c4282c&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c4282c"]])

export default __exports__